/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  test: false,
  dev: true,

  maintenance: false,
  auth: {
    register: true,
    forgotPassword: true,
  },
  oAuth2: {
    google: {
      clientId: '545888765960-imb7k09nm0kjkfarn9ma1i6aiqtuqp7n.apps.googleusercontent.com',
      redirectUri: 'http://localhost:4200/auth/callback-google',
    },
    facebook: {
      clientId: '1994511467352474',
      redirectUri: 'http://localhost:4200/auth/callback-facebook',
    },
  },
};
